export default "https://studio-ui-deployments.apollographql.com/build/static/assets/smb_pipe.0dff6d1e0cb695970cf93ef5df2e3e8f.wav";